<template>
	<section :class="{ 'is-collapsed': collapsed }">
		<header class="RefineSectionHeading" @click="toggleFilter()">
			<i class="lnr-map-marker FilterIcon"></i>
			<div class="Title">Location</div>
			<span v-if="filterHintCount > 0" class="Badge">
				{{ filterHintCount }}
			</span>
			<i class="ToggleIcon" :class="[collapsed ? 'lnr-chevron-down' : 'lnr-chevron-up']"></i>
		</header>

		<div class="RefineContentOptionsList">
			<label class="Label FilterLabel">Where do you want to study?</label>
			<DropdownFilter
				:suggest="suggest"
				:processSelection="processSelection"
				:lastValidSelectionOption="lastValidSelectionOption"
				:inputDisplay="selectionName"
				:filterKey="key"
				placeholder="country, continent or state"
			/>

			<span class="Label SelectedLabel" v-if="selectedCountries.length !== 0 || selectedContinents.length !== 0 ">Selected locations</span>
			<ul class="LocationList">
				<li v-for="item in selectedCountries" :key="item.optionValue">
					<CountryCheckbox
						:optionName="item.optionName"
						:optionValue="item.optionValue"
						:hasAreas="item.hasAreas"
						:class="{ Indented: !item.hasAreas }"
					/>
					<AreaFilter v-if="item.hasAreas" :countryId="item.optionValue" @areaFilterChange="processAreaFilterChange" />
				</li>
			</ul>
			<ul class="LocationList">
				<li v-for="item in selectedContinents" :key="item.optionValue">
					<Checkbox
						:filterKey="continentFilterKey"
						:optionName="item.optionName"
						:optionValue="item.optionValue"
						class="Indented"
					/>
				</li>
			</ul>

			<span class="Label PopularLabel" v-if="popularCountries.length !== 0">Popular locations</span>
			<ul class="LocationList">
				<li v-for="item in popularCountries" :key="item.optionValue" @click="processCountryCheckboxSelection">
					<CountryCheckbox
						:optionName="item.optionName"
						:optionValue="item.optionValue"
						:hasAreas="item.hasAreas"
						:class="{ Indented: !item.hasAreas }"
					/>
					<AreaFilter v-if="item.hasAreas" :countryId="item.optionValue" @areaFilterChange="processAreaFilterChange" />
				</li>
			</ul>
		</div>
	</section>
</template>

<script lang="ts" src="./LocationV2Filter.ts"></script>
<style lang="scss" scoped src="./LocationV2Filter.scss"></style>
